<template>
  <div
    v-accessibility-focus="redirect"
    class="o-button"
    :class="{ 'o-button--outline': outline, 'o-button--padded': outline }"
  >
    <i
      class="o-icon o-button__icon"
      :class="iconClass"
    ></i>
    <span
      v-if="showLabel"
      class="o-typography__label o-button__label"
    >
      {{ label }}
    </span>
  </div>
</template>
<script>
  import { ModalType, ProductType, RouteName } from '@/shared/enums';
  import { ADULT_RATING_AGE } from '@/shared/utils';
  import { link } from '@/index/shared/filters';

  export default {
    props: {
      product: Object,
      outline: Boolean,
      episode: Object,
      channel: Object,
      allowAutoplay: {
        type: Boolean,
        default: false,
      },
      autoplayRedirect: {
        type: Boolean,
        default: false,
      },
      iconClass: {
        type: String,
        default: 'o-icon--play',
      },
      showLabel: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default() {
          return this.$t('glossary.play');
        },
      },
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    mounted() {
      if (this.allowAutoplay && this.$storage.autoplay) {
        this.$storage.autoplay = false;
        this.play();
      }
    },
    methods: {
      redirect() {
        this.$storage.autoplay = true;
        this.$router.push(link(this.product));
      },
      play() {
        const isLoginRequired = this.product.geolocked || this.product.rating >= ADULT_RATING_AGE || this.product.loginRequired;

        if (isLoginRequired && !this.subscriber.isLogged) {
          this.$router.push({ name: RouteName.SUBSCRIBER_LOGIN, query: { redirect: this.$route.fullPath } });
          return;
        }

        return Promise.resolve()
          .then(() => this.checkParentalControl())
          .then(() => this.getWatchItem())
          .then((item) => {
            this.$router.push({
              name: RouteName.DETAIL,
              params: {
                id: item.id,
                slug: item.slug,
                type: item.type.toLowerCase(),
              },
            });
          })
          .catch(() => {});
      },
      checkParentalControl() {
        if (!this.product.rating || this.product.rating < ADULT_RATING_AGE) {
          return Promise.resolve();
        }

        return this.$modal.create({
          id: ModalType.PIN,
          component: () => import('@/index/shared/components/modal/pin-confirmation.vue'),
        }).then((pinModal) => {
          return pinModal.confirmAction({ parentalControlInfo: true });
        });
      },
      getWatchItem() {
        return new Promise((resolve, reject) => {
          if (this.product.type === ProductType.EPISODE) {
            resolve(this.product);
          } else if (this.product.type === ProductType.PROGRAMME && this.product.isCurrent) {
            resolve(this.channel);
          } else if (this.product.type === ProductType.PROGRAMME) {
            resolve(this.product);
          } else if (this.product.type === ProductType.SERIAL) {
            resolve(this.episode);
          } else if (this.product.type === ProductType.VOD) {
            resolve(this.product);
          } else {
            reject();
          }
        });
      },
    },
  };
</script>
